module.exports = __webpack_public_path__ + "img/testimonial-image-02.4dd4e018.png";